import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86c1ee30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap card-header border-0" }
const _hoisted_4 = { class: "flex card-toolbar w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "p-input-icon-left w-10/12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "card-toolbar w-full" }
const _hoisted_9 = { class: "flex flex-col justify-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card-toolbar w-full" }
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "save-form-container" }

import { fetchVariantProductsByPropertyValue, formatCategoriesProduct } from "@/_services/product/variant/productVariant";
import { addVariantProductsToPropertyValue } from "@/_services/propertyValue/propertyValue";
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { IProductVariantForProperty } from "@/models/product/variant/IProductVariantForProperty";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import { fetchCategoriesForDropDown } from "@/_services/category/category";
import { IAddVariantProductsToPropertyValue } from "@/models/product/property/PropertyValue";
import router from "@/router";
import swal from "@/_helpers/swal";

const defaultRowsPerPage = 10;
const tableLocalStorageKey = "selectedTableVariantProduct";
const selectedProductToAddStorageKey = "selectedVariantProductsToAdd";
const selectedProductToRemoveStorageKey = "selectedVariantProductsToRemove";
const selectAllBtnStatusStorageKey = "selectAllVariantProductsBtnStatus";
const dbProductsOfPropertyValueInStorage = "dbProductsOfPropertyValueInStorage";

export default /*#__PURE__*/_defineComponent({
  __name: 'AddVariantProductToPropertyValue',
  setup(__props) {

const productVariants = Array<IProductVariantForProperty>();
const rows = ref<number>(10);
const page = ref < number > (1);
const criteria = ref<string>("");
const currentPage = ref<number>(0);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100, 250];
const totalRecords = ref<number>(0);
const isLoading = ref<boolean>(true);
const tableData = ref<Array<IProductVariantForProperty>>(productVariants);
const route = useRoute();
const propertyValueUuidRouteParam = ref<string | null>(null);
const propertyUuidRouteParam = ref<string>('');
const selectedOptionsCategory = ref<string[]>([]);
const isFormSubmitted = ref<boolean>(false);
const isSelectAllBtnChecked = ref<boolean>(false);
const totalSelectedProductsToAdd = ref<number>(0);
const totalUnSelectedProducts = ref<number>(0);
const refItemsPerPage = ref<number>(0);
const selectedProducts = ref(Array<IProductVariantForProperty>());
const productsOfCurrentPage = ref(Array<IProductVariantForProperty>());
const totalSelectedVariantProductsInDatabase = ref<number>(0);

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
    propertyUuidRouteParam.value = route.params.propertyUuid as string;
    propertyValueUuidRouteParam.value = route.params.uuid as string;
    if (propertyValueUuidRouteParam.value) {
        await populateDataTableWithLocalStorageFilters();
    }
});

watch(selectedOptionsCategory, () => {
    onChangeSelectedCategory();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

const isInFilteredView = computed(() => {
    return selectedOptionsCategory.value.length > 0
        || totalSelectedProductsToAdd.value > 0
        || totalUnSelectedProducts.value > 0;
})

async function searchCategories({ search, page, hasNextPage }) {
    const [totalCategoriesRecordsForPickListApi, categoriesForPickListApi] = await fetchCategoriesForDropDown(5, page, search);
    const hasItems = categoriesForPickListApi.length > 0;
    if (hasItems && page !== totalCategoriesRecordsForPickListApi) {
        hasNextPage();
    }
    
    return categoriesForPickListApi;
}

const populateDataTableWithLocalStorageFilters = async (itemsPerPage?: number, page?: number) => {
    const localStorageRowPerPage = getLocalStorageRowsPerPage();
    const localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    await populateDatatable(currentItemsPerPage as number, currentPage, criteria.value, selectedOptionsCategory.value);
}

const populateDatatable = async (itemsPerPage: number, page: number, criteria: string, categoriesFilter?: string[]) => {
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchVariantProductsByPropertyValue(itemsPerPage, page, criteria, false, propertyValueUuidRouteParam.value, categoriesFilter);
    totalRecords.value = totalRecordsDt;
    isLoading.value = loadingDt;
    tableData.value = tableDataDt;
    refItemsPerPage.value = itemsPerPage;
    productsOfCurrentPage.value = tableData.value;
    totalSelectedVariantProductsInDatabase.value = productsOfCurrentPage.value[0]?.totalSelectedVariantProducts;
    const selectedProductsInDatabaseOnCurrentPage = productsOfCurrentPage.value.filter(item => item.isLinkedPropertyValueParam === true);
    const selectedProductsUuidsInDatabaseOnCurrentPage = selectedProductsInDatabaseOnCurrentPage.map(item => item.uuid);
    addDbProductsToPropertyValueProductsInStorage(selectedProductsUuidsInDatabaseOnCurrentPage);
    let selectedProductsOnCurrentPage: IProductVariantForProperty[] = [];
    selectedProductsOnCurrentPage = productsOfCurrentPage.value.filter((item: IProductVariantForProperty) =>
        (getSelectedProductsToAddFromStorage().includes(item.uuid) || getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid))
        && !getUnSelectedProductsToRemoveFromStorage().includes(item.uuid));
    
    const totalUnSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (itemsPerPage - totalUnSelectedProductsOnCurrentPage) === itemsPerPage;
    selectedProducts.value = selectedProductsOnCurrentPage;
};

const getDatabaseSelectedProductOfPropertyValueFromStorage = (): string[] => {
    const initSelectedProductsOfPropertyValue = localStorage.getItem(dbProductsOfPropertyValueInStorage);
    return initSelectedProductsOfPropertyValue ? JSON.parse(initSelectedProductsOfPropertyValue) : [];
}

const addDbProductsToPropertyValueProductsInStorage = (UuidsCheckedInDb: string[]) => {
    let initProductsOfPropertyValueInStorage = getDatabaseSelectedProductOfPropertyValueFromStorage();
    UuidsCheckedInDb.forEach(uuid => {
        if (!initProductsOfPropertyValueInStorage.includes(uuid)) {
            initProductsOfPropertyValueInStorage.push(uuid);
        }
    });
    localStorage.setItem(dbProductsOfPropertyValueInStorage, JSON.stringify(initProductsOfPropertyValueInStorage));
}

const getSelectedProductsToAddFromStorage = (): string[] => {
    const selectedProductsToAdd = localStorage.getItem(selectedProductToAddStorageKey);
    return selectedProductsToAdd ? JSON.parse(selectedProductsToAdd) : [];
}

const addSelectedProductInProductsToAddInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        totalSelectedProductsToAdd.value = 0;
        localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify([]));
        return;
    }
    
    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    uuids.forEach(uuid => {
        if (!productsToAddInStorage.includes(uuid)) {
            productsToAddInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(productsToAddInStorage));
}

const removeUnSelectedProductFromProductsToAddInStorage = (uuids: string[]) => {
    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !uuids.includes(uuid));
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(newProductsToAddInStorage));
}

const getUnSelectedProductsToRemoveFromStorage = (): string[] => {
    const unSelectedProductsToRemove = localStorage.getItem(selectedProductToRemoveStorageKey);
    return unSelectedProductsToRemove ? JSON.parse(unSelectedProductsToRemove) : [];
}

const addUnSelectedProductInProductsToRemoveInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        totalUnSelectedProducts.value = 0;
        localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify([]));
        return;
    }
    
    let productsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    uuids.forEach(uuid => {
        if (!productsToRemoveInStorage.includes(uuid)) {
            productsToRemoveInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify(productsToRemoveInStorage));
}

const removeSelectedProductInProductsToRemoveInStorage = (uuidsToRemove: string[]) => {
    let currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    let newProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !uuidsToRemove.includes(uuid));
    localStorage.setItem(selectedProductToRemoveStorageKey, JSON.stringify(newProductsToRemoveInStorage));
}

const onChangeSelectedCategory = async (): Promise<void> => {
    showSpinner();
    const search = criteria.value.trim();
    await populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
};

const onSelectAllChange = async (event): Promise<void> => {
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedProducts.value = productsOfCurrentPage.value;
        const selectedProductsUuidsToRemoveInStorage = productsOfCurrentPage.value
            .filter((item: IProductVariantForProperty) =>
                getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid) ||
                getUnSelectedProductsToRemoveFromStorage().includes(item.uuid)
            )
            .map(item => item.uuid);
        removeSelectedProductInProductsToRemoveInStorage(selectedProductsUuidsToRemoveInStorage);

        const selectedProductUuidToSaveInDatabase = productsOfCurrentPage.value
            .filter((item: IProductVariantForProperty) =>
                !getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid)
            )
            .map(item => item.uuid);
        if (selectedProductUuidToSaveInDatabase.length > 0) {
            addSelectedProductInProductsToAddInStorage(selectedProductUuidToSaveInDatabase);
            const currentProductsToAddInStorage = getSelectedProductsToAddFromStorage();
            let newProductsToAddInStorage = currentProductsToAddInStorage;
            selectedProductUuidToSaveInDatabase.forEach((uuid: string) => {
                if (!currentProductsToAddInStorage.includes(uuid)) {
                    newProductsToAddInStorage.push(uuid);
                }
            });
            totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
        }

        const currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
        let newTotalProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !selectedProductsUuidsToRemoveInStorage.includes(uuid));
        totalUnSelectedProducts.value = newTotalProductsToRemoveInStorage.length;
    } else {
        isSelectAllBtnChecked.value = false;
        const unSelectedProductsToRemoveInDatabase = productsOfCurrentPage.value
            .filter((item: IProductVariantForProperty) =>
                !getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid) ||
                getSelectedProductsToAddFromStorage().includes(item.uuid)
            );
        const unSelectedProductsUuidsToRemoveInDatabase = unSelectedProductsToRemoveInDatabase.map(item => item.uuid);
        removeUnSelectedProductFromProductsToAddInStorage(unSelectedProductsUuidsToRemoveInDatabase);

        const unSelectedProductsToRemoveInStorage = productsOfCurrentPage.value
            .filter((item: IProductVariantForProperty) =>
                getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid)
            );
        const unSelectedProductsUuidsToRemoveInStorage = unSelectedProductsToRemoveInStorage.map(item => item.uuid);
        if (unSelectedProductsUuidsToRemoveInStorage.length > 0) {
            addUnSelectedProductInProductsToRemoveInStorage(unSelectedProductsUuidsToRemoveInStorage);
            const productsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
            let newProductsToRemoveInStorage = productsToRemoveInStorage;
            unSelectedProductsUuidsToRemoveInStorage.forEach((uuid: string) => {
                if (!productsToRemoveInStorage.includes(uuid)) {
                    newProductsToRemoveInStorage.push(uuid);
                }
            });
            totalUnSelectedProducts.value = newProductsToRemoveInStorage.length;
        }

        const productsToAddInStorage = getSelectedProductsToAddFromStorage();
        let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductsUuidsToRemoveInDatabase.includes(uuid));
        totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
        selectedProducts.value = selectedProducts.value.filter((item: IProductVariantForProperty) =>
            !productsOfCurrentPage.value.map((product: IProductVariantForProperty) => product.uuid).includes(item.uuid)
        );

        hideSpinner();
    }
};

const onRowSelect = async (event: any): Promise<void> => {
    const selectedProductUuid = event.data.uuid;
    removeSelectedProductInProductsToRemoveInStorage([selectedProductUuid]);
    if (!getDatabaseSelectedProductOfPropertyValueFromStorage().includes(selectedProductUuid)) {
        totalSelectedProductsToAdd.value++;
        addSelectedProductInProductsToAddInStorage([selectedProductUuid]);
    }

    const currentProductsToRemoveInStorage = getUnSelectedProductsToRemoveFromStorage();
    let newTotalProductsToRemoveInStorage = currentProductsToRemoveInStorage.filter(uuid => !selectedProductUuid.includes(uuid));
    totalUnSelectedProducts.value = newTotalProductsToRemoveInStorage.length;
    const totalSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (refItemsPerPage.value - totalSelectedProductsOnCurrentPage) === refItemsPerPage.value;
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedProductUuid = event.data.uuid;
    removeUnSelectedProductFromProductsToAddInStorage([unSelectedProductUuid]);
    if (getDatabaseSelectedProductOfPropertyValueFromStorage().includes(unSelectedProductUuid)) {
        addUnSelectedProductInProductsToRemoveInStorage([unSelectedProductUuid]);
        totalUnSelectedProducts.value = getUnSelectedProductsToRemoveFromStorage().length++;
    }

    const productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductUuid.includes(uuid));
    totalSelectedProductsToAdd.value = newProductsToAddInStorage.length;
    isSelectAllBtnChecked.value = false;
}

const getTotalUnSelectedProductsOnCurrentPage = (): number => {
    const totalUnselectedCurrentPageProductsNotInDbAndAddFromStorage = productsOfCurrentPage.value.filter((item: IProductVariantForProperty) =>
        (!getSelectedProductsToAddFromStorage().includes(item.uuid) && !getDatabaseSelectedProductOfPropertyValueFromStorage().includes(item.uuid))).length;
    const totalUnselectedCurrentPageProductsOnStorage = productsOfCurrentPage.value.filter((item: IProductVariantForProperty) =>
        getUnSelectedProductsToRemoveFromStorage().includes(item.uuid))
        .length;

    return totalUnselectedCurrentPageProductsOnStorage + totalUnselectedCurrentPageProductsNotInDbAndAddFromStorage;
};

const getLocalStorageData = () => {
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

const setLocalStorageRowsPerPage = (rowPerPage: number) =>{
    let storageData = localStorage.getItem(tableLocalStorageKey);
    if (storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(tableLocalStorageKey, JSON.stringify(localStorageObject));
    }
}

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;
    
    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
        }
    }
}

const getIsSelectedAllBtnStatusLocalStorage = (): boolean => {
    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (isSelectedAllBtnInStorageData) {
        return isSelectedAllBtnInStorageData === 'true';
    }

    return false;
}

const getLocalStorageRowsPerPage = () => {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

const getLocalStorageFisrtPageState = () => {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;

    setLocalStorageRowsPerPage(rows.value);
    await populateDataTableWithLocalStorageFilters(rows.value, page.value);
};

const onSearchInputDt = async () => {
    const search = criteria.value.trim();
    if (search.length === 0 || search.length >= 3) {
        showSpinner();
        await populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
    }
}

const canSubmitForm = (): boolean => {
    return !(totalSelectedProductsToAdd.value === 0 && totalUnSelectedProducts.value === 0);
}

const submitFormHandler = async (data) => {
    if (!canSubmitForm()) {
        swal.warning("Vous devez selectionner ou désélectionner au moins un produit.");
    } else {
        swal.confirm("Êtes-vous sur de vouloir ajouter les produits ?")
            .then((result) => {
                if (result.isConfirmed) {
                    showSpinner();
                    const propertyValueUuid = propertyValueUuidRouteParam.value as string;
                    const selectedProductsToAdd = getSelectedProductsToAddFromStorage();
                    const unSelectedProductsToRemove = getUnSelectedProductsToRemoveFromStorage();
                    const params: IAddVariantProductsToPropertyValue  = {
                        uuid: propertyValueUuid,
                        isAllSelected: getIsSelectedAllBtnStatusLocalStorage(),
                        selectedProductsUuidsToAdd: selectedProductsToAdd,
                        unSelectedProductsUuidsToRemove: unSelectedProductsToRemove
                    };
                    addVariantProductsToPropertyValue(params).then(() => {
                        swal.success("Créé !", "Vous venez d'ajouter des produits à la valeur de proprité").then(() => {
                            hideSpinner();
                            router.push({ name: 'CustomPropertyValuesList', params: { uuid: propertyUuidRouteParam.value }})
                        });
                    });
                }
            });

        isFormSubmitted.value = true;    
    }
}

const redirectToLastPage = () => {
    router.back();
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

const initLocalStorageData = () => {
    // Delete
    if (localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.removeItem(selectAllBtnStatusStorageKey);
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.removeItem(selectedProductToAddStorageKey);
    }
    if (localStorage.getItem(selectedProductToRemoveStorageKey)) {
        localStorage.removeItem(selectedProductToRemoveStorageKey);
    }
    if (localStorage.getItem(dbProductsOfPropertyValueInStorage)) {
        localStorage.removeItem(dbProductsOfPropertyValueInStorage);
    }

    // Create
    if (!localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.setItem(selectAllBtnStatusStorageKey, 'false');
    }
    if (!localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.setItem(selectedProductToAddStorageKey, '[]');
    }
    if (!localStorage.getItem(selectedProductToRemoveStorageKey)) {
        localStorage.setItem(selectedProductToRemoveStorageKey, '[]');
    }
    if (!localStorage.getItem(dbProductsOfPropertyValueInStorage)) {
        localStorage.setItem(dbProductsOfPropertyValueInStorage, '[]');
    }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLastPage()))
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _createVNode(_component_FormKit, {
      type: "form",
      "form-class": isFormSubmitted.value ? 'hide' : 'show',
      onSubmit: submitFormHandler,
      actions: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DataTable), {
            ref: "dt",
            lazy: "",
            dataKey: "uuid",
            stateStorage: "local",
            "state-key": tableLocalStorageKey,
            value: tableData.value,
            paginator: true,
            rows: rows.value,
            rowHover: true,
            loading: isLoading.value,
            totalRecords: totalRecords.value,
            currentPage: currentPage.value,
            rowsPerPageOptions: rowsPerPageOptions,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} produits",
            selectAll: isSelectAllBtnChecked.value,
            selection: selectedProducts.value,
            "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((selectedProducts).value = $event)),
            onSelectAllChange: _cache[5] || (_cache[5] = ($event: any) => (onSelectAllChange($event))),
            onRowSelect: _cache[6] || (_cache[6] = ($event: any) => (onRowSelect($event))),
            onRowUnselect: _cache[7] || (_cache[7] = ($event: any) => (onRowUnselect($event))),
            onPage: _cache[8] || (_cache[8] = ($event: any) => (onPaginate($event)))
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_unref(InputText), {
                        type: "text",
                        class: "w-9/12",
                        modelValue: criteria.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria).value = $event)),
                        placeholder: "Rechercher un produit",
                        onInput: _cache[2] || (_cache[2] = ($event: any) => (onSearchInputDt()))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, "Nombre total de produits : " + _toDisplayString(totalRecords.value), 1),
                    _createElementVNode("p", null, "Nombre total de produits déjà sélectionné : " + _toDisplayString(totalSelectedVariantProductsInDatabase.value), 1),
                    _createElementVNode("p", null, "Nombre de produit à rajouter : " + _toDisplayString(totalSelectedProductsToAdd.value), 1),
                    _createElementVNode("p", null, "Nombre de produit à supprimer : " + _toDisplayString(totalUnSelectedProducts.value), 1),
                    (isInFilteredView.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Vous êtes en vue filtrée"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_FormKit, {
                    type: "taglist",
                    name: "selected-category-filter",
                    label: "Rechercher une catégorie",
                    placeholder: "Example: E-billet",
                    modelValue: selectedOptionsCategory.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedOptionsCategory).value = $event)),
                    options: searchCategories,
                    "selection-appearance": "option",
                    multiple: "",
                    "empty-message": "Aucune catégorie trouvée",
                    "load-on-created": "false",
                    loadOnScroll: "false",
                    debounce: "1000"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("Aucun produit trouvé.")
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(Column), { selectionMode: "multiple" }),
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Produit"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "brand",
                  header: "Marque"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.brand), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "category",
                  header: "Catégorie"
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.categories?.length > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: _unref(formatCategoriesProduct)(slotProps.data.categories)
                        }, _toDisplayString(slotProps.data.categories[0].value), 9, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["value", "rows", "loading", "totalRecords", "currentPage", "selectAll", "selection"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_FormKit, {
            type: "submit",
            label: "Enregistrer",
            disabled: isLoading.value
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["form-class"])
  ], 64))
}
}

})